<template>
    <div v-click-outside="hide">
        <input type="text" :name="name" :id="id"
               :class="[ selectClass, isActive ? 'rounded-b-none border-b-0 outline-none' : '' ]"
               :value="year"
               :placeholder="placeholder"
               @focus="getResults"
               @keydown="onKeyDown"
               autocomplete="off">
        <transition name="slide">
            <ul class="border rounded rounded-t-none overflow-auto" v-show="isActive">
                <li class="flex flex-col lg:flex-row p-2 text-sm px-4 cursor-pointer"
                    :class="[ key === currentIndex ? 'bg-gray-300' : 'even:bg-gray-100' ]"
                    v-for="(item, key) in filteredResults" v-bind:key="key" @click.prevent="addItem(key)">
                    <span class="w-full">{{ item }}</span>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            selectClass: {
                type: String,
                default: 'form-control'
            },

            years: {
                type: Array
            },

            id: {
                type: String,
                required: true,
            },

            name: {
                type: String,
                required: true,
            },

            placeholder: {
                type: String,
                default: 'Search'
            },

            year: {
                type: Number,
            }
        },


        data() {
            return {
                search: this.year,
                isActive: false,

                currentIndex: this.years ? this.years.indexOf(this.year) : null
            }
        },

        methods: {
            hide() {
                this.isActive = false;
            },

            getResults() {
                this.isActive = true;
            },

            onKeyDown(e) {
                if (this.isActive) {
                    if (e.key === 'ArrowDown') {
                        this.onPressArrowDown();
                    }

                    if (e.key === 'ArrowUp') {
                        this.onPressArrowUp();
                    }

                    if (e.key === 'Enter') {
                        this.onPressEnter();
                    }
                }
            },

            onPressArrowDown() {
                if ((this.currentIndex + 1) !== this.years.length) {
                    return this.currentIndex++;
                }
            },

            onPressArrowUp() {
                if (this.currentIndex > 0) {
                    return this.currentIndex--;
                }
            },

            onPressEnter() {
                let item = this.years[this.currentIndex];

                return this.addItem(item);
            },

            addItem(item) {
                this.search = this.years[item]
                this.currentIndex = item

                this.$emit('addYearItem', this.search);

                this.isActive = false;
            },
        },

        computed: {
            filteredResults() {
                return this.years;
            }
        },
    }
</script>
